import { render } from "./TicketMailView.vue?vue&type=template&id=f126fca6&scoped=true"
import script from "./TicketMailView.vue?vue&type=script&lang=js"
export * from "./TicketMailView.vue?vue&type=script&lang=js"

import "./TicketMailView.vue?vue&type=style&index=0&id=f126fca6&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f126fca6"]])

export default __exports__